import { AttributeLabelsState } from "@idw-types/state/attribute-labels-state";
import { AttributeLabelsActionTypes, AttributeLabelsActions } from "../actions/attribute-labels-actions";

export const initialAttributeLabelsState: AttributeLabelsState = {
    attributeLabels: {
        isLoading: false,
        attributeLabels: null
    }
};

export const attributeLabelsReducer = (
    state: AttributeLabelsState = initialAttributeLabelsState,
    action: AttributeLabelsActions
): AttributeLabelsState => {
    switch (action.type) {
        // Attribute Labels
        case AttributeLabelsActionTypes.SET_ATTRIBUTE_LABELS_LOADING:
            return {
                ...state,
                attributeLabels: {
                    ...(action.payload.isLoading
                        ? { ...initialAttributeLabelsState.attributeLabels }
                        : { ...state.attributeLabels }),
                    isLoading: action.payload.isLoading
                }
            };
        case AttributeLabelsActionTypes.SET_ATTRIBUTE_LABELS:
            return {
                ...state,
                attributeLabels: {
                    ...state.attributeLabels,
                    attributeLabels: action.payload.axnAttributeLabels,
                    isLoading: false
                }
            };
        case AttributeLabelsActionTypes.ADD_ATTRIBUTE_LABEL:
            return {
                ...state,
                attributeLabels: {
                    ...state.attributeLabels,
                    attributeLabels: state.attributeLabels.attributeLabels
                        ? [...state.attributeLabels.attributeLabels, action.payload.attributeLabel]
                        : [action.payload.attributeLabel]
                }
            };
        default:
            return state;
    }
};